import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/store';

import { applyExtraFilters, resetExtraFilters } from '../../../../store/filters/actions';
import { generateQueryString } from '../../../../utils/filters';
import { ExtraFiltersModal, IExtraFiltersModalOwnProps } from './index';

export interface IExtraFiltersModalStateProps {
  linkHref: string;
  showBlackFridayFilter?: boolean;
}

export function mapStateToProps({ filters, blackFridaySettings }: IApplicationState): IExtraFiltersModalStateProps {
  const { isActive, url } = blackFridaySettings;

  return {
    linkHref: `${window.location.pathname}${generateQueryString({ ...filters, p: 1 })}`,
    showBlackFridayFilter: isActive && !!url,
  };
}

export interface IExtraFiltersModalDispatchProps {
  applyFilters(): void;
  resetFilters(): void;
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IExtraFiltersModalDispatchProps {
  return {
    applyFilters: () => dispatch(applyExtraFilters()),
    resetFilters: () => dispatch(resetExtraFilters()),
  };
}

export const ExtraFiltersModalContainer = connect<
  IExtraFiltersModalStateProps,
  IExtraFiltersModalDispatchProps,
  IExtraFiltersModalOwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(ExtraFiltersModal);
